const getYearToUseFromTheme = themeContent => themeContent && themeContent.child('year').metadata('yearToUse').value();

export const getYearToUse = (themeContent, year) => getYearToUseFromTheme(themeContent) || year;

export const getThemeToUse = themeContent => themeContent && themeContent.child('theme').metadata('useTheme').value();
